(() => {
  'use strict';

  const VERSION = '2026-07-14-v1';
  const PATCH_COPY =
    'Before first full-face use, test a small amount behind the ear or on the inner forearm and use it according to the directions. Wait 24 hours and stop use if irritation occurs.';

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const handle = () => window.location.pathname.replace(/\/+$/, '').split('/').pop() || '';

  const findAccordion = (...labels) => {
    const wanted = labels.map(normalize);
    return [...document.querySelectorAll('details[data-testid="accordion-details"]')].find((details) =>
      wanted.includes(normalize(details.querySelector('summary')?.textContent)),
    );
  };

  const setHowTo = (html) => {
    const content = findAccordion('How to use', 'How to Use')?.querySelector('.details-content');
    if (!content || content.dataset.sovahActiveFix === VERSION) return;
    content.innerHTML = html;
    content.dataset.sovahActiveFix = VERSION;
  };

  const dedupeVisibleLabel = (label) => {
    const wanted = normalize(label);
    const matches = [...document.querySelectorAll('main h1, main h2, main h3, main h4, main p, main span')]
      .filter((element) => normalize(element.textContent) === wanted)
      .filter((element) => !element.closest('.details-content'));
    matches.slice(1).forEach((element) => {
      const block = element.closest('.text-block') || element.parentElement;
      if (block) block.remove();
    });
  };

  const apply = () => {
    if (!window.location.pathname.includes('/products/')) return;

    switch (handle()) {
      case 'aha-peeling-concentrate':
        setHowTo(`<h4>How to Use</h4>
          <p>Apply 1 pump of <strong>AHA Peeling Concentrate Exfoliating Face Serum</strong> to clean, dry skin in the evening. Gently spread over the face and neck, avoiding the eyes and lips. Leave on overnight. Start 1–2 times per week and increase only if your skin tolerates it well. Follow with a gentle hydrating serum or moisturiser.</p>
          <h4>Patch Test Recommendation</h4><p>${PATCH_COPY}</p>
          <h4>Caution</h4>
          <p>For external use only. Contains 10% lactic acid. Do not use on irritated or broken skin. Avoid the eyes and lips. Do not use on the same evening as the Brightening Face & Body Exfoliating Cleanser with Kojic Acid or the Natural Retinol Alternative Oil Serum. Mild brief tingling can occur, but burning, persistent stinging, marked redness, or irritation is a reason to rinse off and discontinue use. Use sunscreen during the day and limit prolonged sun exposure.</p>
          <h4>Best Combined With</h4>
          <p><strong>Hydrating Face Serum with Aloe & Hyaluronic Acid</strong> – for a gentle hydration step after the treatment.<br><br><strong>Ceramide Barrier Night Cream for Dry & Normal Skin</strong> – to support skin comfort after exfoliation.<br><br><strong>Sun Protection SPF50 Stick, no tint</strong> – as a separate daytime sunscreen.</p>`);
        break;

      case 'brightening-face-body-exfoliator-with-kojic-acid':
        setHowTo(`<h4>How to Use</h4>
          <p>Apply a small amount of <strong>Brightening Face & Body Exfoliating Cleanser with Kojic Acid</strong> to damp skin. Massage gently in circular motions for 30–60 seconds, avoiding the eye area, then rinse thoroughly with lukewarm water. Start once weekly and use no more than 1–2 times per week if well tolerated.</p>
          <h4>Patch Test Recommendation</h4><p>${PATCH_COPY}</p>
          <h4>Caution</h4>
          <p>For external use only. Do not use on irritated, broken, or freshly shaved skin. Avoid the eye area. Do not use on the same day as AHA Peeling Concentrate or Natural Retinol Alternative Oil Serum. Reduce frequency or discontinue if redness, dryness, or irritation occurs. Use sunscreen on exposed skin during the day.</p>
          <h4>Best Combined With</h4>
          <p><strong>Hydrating Toner</strong> – for a gentle hydration step after rinsing.<br><br><strong>Dark Spot Face Cream with Kojic Acid</strong> – introduce separately rather than layering immediately after exfoliation if your skin is sensitive.<br><br><strong>Sun Protection SPF50 Stick, no tint</strong> – for exposed facial skin during the day.</p>`);
        break;

      case 'dark-spot-face-cream-with-kojic-acid':
        setHowTo(`<h4>How to Use</h4>
          <p>Apply a small amount of <strong>Dark Spot Face Cream with Kojic Acid</strong> to clean, dry skin and gently massage over the face and neck, avoiding the eye area. Start once daily. Increase to morning and evening only if your skin tolerates it well. Use a broad-spectrum sunscreen during the day.</p>
          <h4>Patch Test Recommendation</h4><p>${PATCH_COPY}</p>
          <h4>Caution</h4>
          <p>For external use only. Contains 1% kojic acid. Avoid direct contact with eyes and do not use on irritated or broken skin. Introduce gradually, especially if your skin is sensitive. If irritation, redness, or persistent stinging occurs, reduce frequency or discontinue use. Daily sun protection is recommended.</p>
          <h4>Best Combined With</h4>
          <p><strong>Vitamin C Serum</strong> – introduce separately and use only if the combination is well tolerated.<br><br><strong>Sun Protection SPF50 Stick, no tint</strong> – as the final morning step.<br><br><strong>Hydrating Face Serum with Aloe & Hyaluronic Acid</strong> – for an optional hydration step before the cream.</p>`);
        break;

      case 'natural-retinol-alternative-oil-serum':
        setHowTo(`<h4>How to Use</h4>
          <p>Apply 2–3 drops of <strong>Natural Retinol Alternative Oil Serum</strong> to clean, dry skin in the evening, avoiding the eye area. Start 2–3 evenings per week and increase only if your skin tolerates it well. Use after water-based serums and before or instead of a final cream, depending on your skin's needs.</p>
          <h4>Patch Test Recommendation</h4><p>${PATCH_COPY}</p>
          <h4>Caution</h4>
          <p>For external use only. Avoid direct contact with eyes and do not apply to irritated or broken skin. Do not use on the same evening as AHA Peeling Concentrate or Brightening Face & Body Exfoliating Cleanser with Kojic Acid. Reduce frequency or discontinue if irritation occurs. Use sunscreen during the day.</p>
          <h4>Best Combined With</h4>
          <p><strong>Micellar Cleansing Water</strong> – for gentle cleansing before application.<br><br><strong>Peptide Anti-Aging Serum</strong> – use as a water-based serum before the oil if well tolerated.<br><br><strong>Ceramide Barrier Night Cream for Dry & Normal Skin</strong> – use before or after the oil according to preferred texture and comfort.<br><br><strong>Smoothing Eye Cream</strong> – apply separately around the orbital bone.</p>`);
        dedupeVisibleLabel('Gluten Free');
        break;
    }
  };

  let timer;
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(apply, 60);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();

  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();